import { useQuery } from "@tanstack/react-query";

import {
  IHospitalStaffResponse,
  IStaffTableData,
  ITaggableHcp,
} from "../../@types/Staff";
import { staffService } from "../../services/staffService";

export function getTableHospitalStaff() {
  const { data, isFetching, isError, refetch, isRefetching } = useQuery<
    IHospitalStaffResponse[]
  >({
    queryKey: ["table-hospital-staff"],
    queryFn: async () => {
      const { data } = await staffService.getHospitalStaff();

      return data;
    },
  });

  return {
    staff: data?.map((staffData) => {
      return { ...staffData } as IStaffTableData;
    }),
    isFetching,
    isError,
    refetch,
    isRefetching,
  };
}

/**
 * Fetches all HCPs that the authenticated user can tag in a note for the given
 * patient. The list is small (typically tens, not hundreds) so we fetch once
 * and the @-mention dropdown filters client-side as the user types.
 */
export function useTaggableHcps(patientId: number | undefined) {
  return useQuery<ITaggableHcp[]>({
    queryKey: ["taggable-hcps", patientId],
    queryFn: async () => {
      if (!patientId) return [];
      const { data } = await staffService.getTaggableHcpsForPatient(patientId);
      return data;
    },
    enabled: !!patientId,
    staleTime: 60_000,
  });
}
